import { createFileRoute } from "@tanstack/react-router";
import { AgendaShell } from "@/components/agenda/agenda-shell";
import { AgendaAtendimentos } from "@/components/agenda/agenda-atendimentos";

export const Route = createFileRoute("/agenda/atendimentos")({
  component: () => (
    <AgendaShell>
      <AgendaAtendimentos />
    </AgendaShell>
  ),
  head: () => ({ meta: [{ title: "Atendimentos — Agenda — GPS Drive" }] }),
});
